import { Form, FormProps } from 'antd';

import { FailReport } from '@/model/FailReport/FailReport';
import { FailReportItem } from '@/model/FailReport/FailReportItem';

import FailReportItems from '../FailReportItems/FailReportItems';
import FailReportDetailForm from './FailReportDetailForm';
import useFailReportForm from './useFailReportForm';

interface FailReportFormProps {
  formProps: FormProps<FailReport>;
  failReportItems: FailReportItem[];
  setFailReportItems: (items: FailReportItem[]) => void;
  edit?: boolean;
}

const FailReportForm = (props: FailReportFormProps) => {
  const { formProps, failReportItems, setFailReportItems, edit } = props;
  const { ticketsSelectProps, categorySelectProps, subcategorySelectProps, formInitialValues } =
    useFailReportForm(formProps, edit);

  return (
    <Form
      {...formProps}
      initialValues={formInitialValues}
      className="FailReportForm"
      layout="vertical">
      <FailReportDetailForm
        ticketsSelectProps={ticketsSelectProps}
        categorySelectProps={categorySelectProps}
        subcategorySelectProps={subcategorySelectProps}
        editMode={edit}
      />
      <FailReportItems
        failReport={formProps.initialValues?.id}
        failReportItems={failReportItems}
        setFailReportItems={setFailReportItems}
        canEditItems
      />
    </Form>
  );
};

export default FailReportForm;
